const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

const nav = $('.nav');
$('.mobile-toggle')?.addEventListener('click', () => nav?.classList.toggle('open'));

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  $$('.reveal').forEach(el => observer.observe(el));
} else {
  $$('.reveal').forEach(el => el.classList.add('visible'));
}

const drawer = $('.cart-drawer');
const cartItems = $('.cart-items');
const cartCounts = $$('.cart-count');
const cartTotal = $('.cart-total strong');
const moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
  style: 'currency',
  currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD'
});
const money = cents => moneyFormatter.format((Number(cents) || 0) / 100);

function openCart() {
  drawer?.classList.add('open');
  drawer?.setAttribute('aria-hidden', 'false');
}
function closeCart() {
  drawer?.classList.remove('open');
  drawer?.setAttribute('aria-hidden', 'true');
}
$('.cart-open')?.addEventListener('click', async () => { await refreshCart(); openCart(); });
$('.close-cart')?.addEventListener('click', closeCart);
$('.cart-backdrop')?.addEventListener('click', closeCart);
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });
refreshCart();

async function getCart() {
  const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
  if (!res.ok) throw new Error('Unable to load cart');
  return res.json();
}

async function refreshCart() {
  if (!cartItems) return;
  try {
    const cart = await getCart();
    cartCounts.forEach(el => el.textContent = cart.item_count);
    if (cartTotal) cartTotal.textContent = money(cart.total_price);
    if (!cart.items.length) {
      cartItems.innerHTML = `<div class="cart-empty">${escapeHtml(window.RevelText?.cartEmpty || 'Your collection starts here.')}</div>`;
      return;
    }
    cartItems.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <div class="cart-thumb">${item.image ? `<img src="${item.image}" alt="">` : ''}</div>
        <div>
          <strong>${escapeHtml(item.product_title)}</strong>
          <small>${money(item.final_line_price)}</small>
          <span class="cart-qty">Qty ${item.quantity}</span>
        </div>
        <button class="remove-item" type="button" data-key="${item.key}">${escapeHtml(window.RevelText?.remove || 'Remove')}</button>
      </div>`).join('');
    $$('.remove-item', cartItems).forEach(btn => btn.addEventListener('click', async () => {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
      });
      refreshCart();
    }));
  } catch (e) {
    cartItems.innerHTML = '<div class="cart-empty">Cart could not be loaded. You can still use the full cart page.</div>';
  }
}

async function addVariant(variantId, quantity = 1) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) })
  });
  if (!res.ok) throw new Error('Could not add item');
  await refreshCart();
  openCart();
}

$$('.quick-add').forEach(btn => btn.addEventListener('click', async (e) => {
  e.preventDefault();
  e.stopPropagation();
  btn.disabled = true;
  try {
    await addVariant(btn.dataset.variantId, 1);
  } catch (err) {
    console.error(err);
  } finally {
    btn.disabled = false;
  }
}));

$('[data-variant-select]')?.addEventListener('change', (e) => {
  const option = e.target.selectedOptions[0];
  const price = $('[data-product-price]');
  if (price && option?.dataset.price) price.textContent = option.dataset.price;
});

$$('.thumb-button').forEach(btn => btn.addEventListener('click', () => {
  const main = $('.product-main-image');
  if (main && btn.dataset.imageSrc) {
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = btn.dataset.imageSrc;
  }
}));

$('[data-shopify-sort]')?.addEventListener('change', (e) => {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', e.target.value);
  window.location.href = url.toString();
});

const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

function applyTilt(card) {
  if (!supportsHover || window.innerWidth < 900) {
    card.style.transform = '';
    return;
  }
  const damp = 14;
  let rafId = null;
  let pendingX = 0;
  let pendingY = 0;
  const update = () => {
    const rx = -((pendingY) - 0.5) * damp;
    const ry = ((pendingX) - 0.5) * damp;
    card.style.transform = `perspective(1200px) rotateX(${rx}deg) rotateY(${ry}deg) translateY(-4px)`;
    rafId = null;
  };
  card.addEventListener('mousemove', (e) => {
    const rect = card.getBoundingClientRect();
    pendingX = (e.clientX - rect.left) / rect.width;
    pendingY = (e.clientY - rect.top) / rect.height;
    if (!rafId) rafId = requestAnimationFrame(update);
  }, { passive: true });
  card.addEventListener('mouseleave', () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
    card.style.transform = 'perspective(1200px) rotateX(0deg) rotateY(0deg) translateY(0px)';
  });
}
$$('[data-tilt]').forEach(applyTilt);
window.addEventListener('resize', () => {
  if (!supportsHover || window.innerWidth < 900) {
    $$('[data-tilt]').forEach(card => { card.style.transform = ''; });
  }
}, { passive: true });

const header = $('[data-site-header]');
window.addEventListener('scroll', () => {
  if (!header) return;
  header.classList.toggle('scrolled', window.scrollY > 14);
}, { passive: true });

function escapeHtml(str = '') {
  return String(str).replace(/[&<>'"]/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '\'':'&#39;', '"':'&quot;' }[c]));
}
